module.exports = __webpack_public_path__ + "static/media/21.7b19124e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/21.svg
// module id = 142
// module chunks = 0